import { useContext } from "react";

import type { LoggerContract } from "@core/foundation/logger";

import { LoggerContext } from "./context.ts";

export function useLogger(): LoggerContract {
  const context = useContext(LoggerContext);

  if (!context) {
    throw new Error("useLogger must be used within LoggerContext.Provider");
  }

  return context;
}
